export class Unternehmen {
  guid: string = '';
  firmenname: string = '';
  firmennummer: string = '';
  strasse: string = '';
  plz: string = '';
  ort: string = '';
  land: string = '';
  ansprechpartner: string = '';
  ansprechpartnerEmail: string = '';
  ansprechpartnerTel: string = '';
  datenverarbeitungErlaubt: boolean = true;
  isDeleted: number = 0;
}
